import _ from 'lodash';

const getFromTask = (state, path) => _.get(state, `internalStore.task.${path}`, null);

/**
 * @return {String|Object|null}
 */
export const getError = state => getFromTask(state, 'taskUpdate.error');

/**
 * @return {Boolean}
 */
export const getUpdateFetchingFlag = state => getFromTask(state, 'taskUpdate.isFetching');

/**
 * @return {String}
 */
export const getTaskUpdateStatus = state => getFromTask(state, 'taskUpdate.status');

/**
 * @return {Number}
 */
export const getLastTaskId = state => getFromTask(state, 'taskUpdate.taskId');

/**
 * @return {Boolean}
 */
export const getTaskOffersFetchingFlag = state => getFromTask(state, 'taskOffersFetching');
